import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"




export default /*@__PURE__*/_defineComponent({
  __name: 'StarsItem',
  props: {
    index: {},
    baseSequence: {},
    starData: {},
    aptStar: {}
  },
  setup(__props: any) {



const starOptions = {
  fontSize: 18,
  fontStyle: 700,
  fontFamily: "SF Pro Text, sans-serif",
  align: "center",
};

const currentStarCircleConfig = {
  radius: 13,
  stroke: "#000000",
  strokeWidth: 1,
};

return (_ctx: any,_cache: any) => {
  const _component_v_text = _resolveComponent("v-text")!
  const _component_v_rect = _resolveComponent("v-rect")!
  const _component_v_group = _resolveComponent("v-group")!
  const _component_v_circle = _resolveComponent("v-circle")!

  return (_openBlock(), _createBlock(_component_v_group, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_text, {
        x: -26,
        y: -48,
        config: {
        text: `${__props.baseSequence}`,
        fontSize: 16,
        fontStyle: 700,
        fontFamily: 'SF Pro Text, sans-serif',
      },
        fill: "#000000",
        align: "center",
        width: 56
      }, null, 8, ["config"]),
      _createVNode(_component_v_group, {
        x: -28,
        y: -28
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_rect, {
            x: 0,
            y: 0,
            width: 56,
            height: 56,
            stroke: "#9C9592",
            fill: "#FFFFFF",
            "stroke-width": 1,
            "corner-radius": "20px"
          }),
          _createVNode(_component_v_text, {
            x: -14,
            y: 6,
            text: __props.starData.sk,
            config: starOptions,
            width: 56
          }, null, 8, ["text"]),
          _createVNode(_component_v_text, {
            x: 14,
            y: 6,
            text: __props.starData.sf,
            config: starOptions,
            width: 56
          }, null, 8, ["text"]),
          _createVNode(_component_v_text, {
            x: 0,
            y: 32,
            text: __props.starData.sb,
            config: starOptions,
            width: 56
          }, null, 8, ["text"])
        ]),
        _: 1
      }),
      (__props.aptStar)
        ? (_openBlock(), _createBlock(_component_v_group, {
            key: 0,
            x: 26,
            y: 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_circle, {
                x: 20,
                y: -16,
                config: currentStarCircleConfig,
                fill: __props.aptStar.year == 5 ? '#EE441A' : '#FFFFFF'
              }, null, 8, ["fill"]),
              _createVNode(_component_v_text, {
                x: 15,
                y: -25,
                text: __props.aptStar.year.toString(),
                fill: __props.aptStar.year == 5 ? '#FFFFFF' : '#000000',
                config: starOptions
              }, null, 8, ["text", "fill"]),
              _createVNode(_component_v_circle, {
                x: 20,
                y: 16,
                config: currentStarCircleConfig,
                fill: __props.aptStar.month == 5 ? '#EE441A' : '#FFFFFF'
              }, null, 8, ["fill"]),
              _createVNode(_component_v_text, {
                x: 15,
                y: 7,
                text: __props.aptStar.month.toString(),
                fill: __props.aptStar.month == 5 ? '#FFFFFF' : '#000000',
                config: starOptions
              }, null, 8, ["text", "fill"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})